import React from 'react'

import InternalMusicItem from './_components/InternalMusicItem'

import type { InternalMusicItemProps } from './_components/InternalMusicItem'
import type { AudioGlobalMetadata } from '@/hooks/audio/store'
import type { MusicPlayStatus } from '@/components/MusicProfile/constants'

import { useDiscoverTrack } from '@/pages/tad.ai/_hooks/discoverTrack'


import { useGlobalAudioPlayer } from '@/hooks/audio/store';
import { useMemo } from 'react';
export interface MusicItemProps<T extends AudioGlobalMetadata>
  extends InternalMusicItemProps {
  fromList?: T[]
}

const MusicItem = <T extends AudioGlobalMetadata>(props: MusicItemProps<T>) => {
  const { data, fromList } = props

  const globalPlayer = useGlobalAudioPlayer()
  const isGlobalMusic = globalPlayer.match(data.id)
  const playing = globalPlayer.playing
  const { trackDiscover } = useDiscoverTrack(data.id)
  const handlePlay = (playStart?: number) => {
    if (data.status !== 'success') {
      return
    }
    globalPlayer.play(data, playStart, fromList)
    trackDiscover('play_click')
  }

  const playStatus: MusicPlayStatus = useMemo(() => {
    if (!isGlobalMusic) {
      return 'idle'
    }
    return playing ? 'playing' : 'paused'
  }, [isGlobalMusic, playing])

  return (
    <InternalMusicItem
      onAudioPlay={(playStart) => handlePlay(playStart)}
      playStatus={playStatus}
      {...props}
    />
  )
}

export default MusicItem
